export const COLORS = {
  winwireBlue: '#002E6D',
  linkBlue: '#1976d2',
  winwireOrange: '#C74627',
  white: '#FFFFFF',
  lightGray: '#F5F5F5',
  borderGray: 'rgba(0, 0, 0, 0.12)',
  textSecondary: '#666666',
  success: '#4CAF50',
  error: '#F44336',
  active: '#4CAF50',
  inactive: '#F44336',
};

export const FONTS = {
  primary: 'Helvetica, Arial, sans-serif',
};

export const API_BASE_URL = 'http://localhost:5097/api';

export const ITEMS_PER_PAGE = 10;
